export enum HaAdminFilterTypeEnum {
    all=0,
    active,
    blocked,
    inactive
}